import {
    FlexySelectFormStructure,
    FormObject,
    FormStructure,
} from '@europrocurement/flexy-form/components';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { jsonSelectInput } from '../types/formTypes';
import { checkFieldValue } from '../functions';

const jsonSelectInputToFormElement: (input: jsonSelectInput) => FormStructure = (input) => {
    const baseField: FlexySelectFormStructure = {
        type: 'select',
        name: input.name,
        inputlabel: input.inputlabel,
        placeholder: input.placeholder,
        xs: input.xs,
        sm: input.sm,
        md: input.md,
        lg: input.lg,
        sx: {
            fontSize: '14px',
            marginTop: '15px',
            marginBottom: '15px',
            fontWeight: '500',
        },
        tooltip: input.tooltip,
    };

    if (input.valuesfrom.options) {
        const optionsFlexySelect = Object.entries(input.valuesfrom.options).map((option) => ({
            value: option[0],
            label: option[1],
        }));
        baseField.options = optionsFlexySelect;
    }

    if (input.defaultvalue) {
        baseField.defaultValue = {
            value: input.defaultvalue.value,
            label: input.defaultvalue.label,
        };
    }

    if (input.valuesfrom.api) {
        baseField.optionsResolver = {
            name: 'listeSelectionDataResolver',
            params: {
                api: input.valuesfrom.api.name,
                endpoint: input.valuesfrom.api.endpoint,
                discriminant: input.valuesfrom.api.params.discriminant,
            },
        };
    }

    // comportement sur rules display
    if (input.rules && input.rules.display) {
        if (input.rules.display.fieldIsEqualTo) {
            const fieldNameToWatch = input.rules.display.fieldIsEqualTo.field;
            const valueToWatch = String(input.rules.display.fieldIsEqualTo.value);

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) => {
                const valueWatch: string = formContext.watch(fieldNameToWatch as string)?.value;
                const fieldToWatch: NodeListOf<HTMLElement> =
                    document.getElementsByName(fieldNameToWatch);

                return Array.from(fieldToWatch).length > 0 && Array.isArray(valueToWatch)
                    ? valueToWatch.includes(valueWatch)
                    : valueWatch === valueToWatch;
            };
        }
        if (input.rules.display.fieldIsChecked) {
            const fieldNameToWatch = input.rules.display.fieldIsChecked;

            baseField.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
    }

    // comportement de toute la partie disabled
    if (input.disabled) {
        if (input.disabled === true) {
            baseField.isDisabled = true;
        } else if (input.disabled.isFalse) {
            const fieldNameToWatch =
                typeof input.disabled.isFalse === 'string'
                    ? input.disabled.isFalse
                    : input.disabled.isFalse.field;
            baseField.isDisabled = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                !checkFieldValue(formContext, true, fieldNameToWatch);
        } else if (input.disabled.isValid) {
            const fieldNameToWatch =
                typeof input.disabled.isValid === 'string'
                    ? input.disabled.isValid
                    : input.disabled.isValid.field;
            baseField.isDisabled = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                !checkFieldValue(formContext, true, fieldNameToWatch);
        } else if (input.disabled.fieldIsNotEqualTo) {
            const fieldNameToWatch = input.disabled.fieldIsNotEqualTo.field;
            const valueToWatch = input.disabled.fieldIsNotEqualTo.value;
            baseField.isDisabled = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                !checkFieldValue(formContext, valueToWatch, fieldNameToWatch);
        } else if (input.disabled.fieldIsEqualTo) {
            const fieldNameToWatch = input.disabled.fieldIsEqualTo.field;
            const valueToWatch = input.disabled.fieldIsEqualTo.value;
            baseField.isDisabled = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, valueToWatch, fieldNameToWatch);
        }
    }

    return baseField;
};

export default jsonSelectInputToFormElement;
